<template>
  <SectionsBase :title="demosTitle" :list="demosList" url-name="Demos" />
</template>

<script>
import { mapState } from 'vuex'
import SectionsBase from '@/components/HomeSectionsSectionBase'

export default {
  components: { SectionsBase },

  computed: {
    ...mapState('sections', ['demosTitle', 'demosList']),
  },

  mounted() {
    this.$store.dispatch('sections/fetchHomeDemoSectionsText')
    this.$store.dispatch('sections/fetchHomeDemoSectionsList')
  },
}
</script>
